import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CheckProductionDatesParamsType } from './types/check-production-dates-params.type';

@Component({
  selector: 'app-check-production-dates',
  templateUrl: './check-production-dates.component.html',
  styleUrls: ['./check-production-dates.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CheckProductionDatesComponent {
  checkProductionDateParams: CheckProductionDatesParamsType | null = null;

  onFormSubmitted(formData: CheckProductionDatesParamsType): void {
    this.checkProductionDateParams = formData;
  }

  onClearResult(): void {
    this.checkProductionDateParams = null;
  }
}
